import { useBudgetContext } from "Hooks/useBudgetContext";

import { Button } from "Components/Button";
import { CardProduct } from "Components/Cards/CardProduct";

import { ModalProductsWarning } from "Pages/ServiceForm/ModalsProductsWarning";
import { ProductsResultSearchProps } from "./interface";
import { ContainerProductList } from "./styles";
import { useCartAmount } from "./useCartAmount";

export const ProductsResultSearch = ({
  openProductDetails,
  productList,
  addDetailButton,
}: ProductsResultSearchProps) => {
  const {
    handleAddProduct,
    partnersOptions,
    handleRemoveToCart,
    closeModal,
    modal,
    preparation,
    cancelAddProduct,
    proceedAddProduct,
    handleConfirmPartnerSelection,
    handleChangePartner,
  } = useCartAmount();

  const { loadingCart, partnerSelected } = useBudgetContext();

  return (
    <>
      <ContainerProductList className="products-results">
        <table>
          <thead>
            <tr>
              <th>SKU</th>
              <th>PRODUTO</th>
              <th>SINONÍMIA</th>
              <th>STATUS/VALOR</th>
              <th>AÇÕES</th>
            </tr>
          </thead>

          <tbody>
            {productList.map((product) => (
              <CardProduct
                key={product.id}
                product={product}
                addToCart={() => handleAddProduct(product)}
                removeToCart={() => handleRemoveToCart(product)}
              >
                {addDetailButton && (
                  <Button
                    outlined
                    onClick={() => openProductDetails(product.id)}
                  >
                    {" "}
                    Saiba Mais
                  </Button>
                )}
              </CardProduct>
            ))}
          </tbody>
        </table>
      </ContainerProductList>

      <ModalProductsWarning
        closeModal={closeModal}
        modal={modal}
        handleChangePartner={handleChangePartner}
        cancelAddProduct={cancelAddProduct}
        proceedAddProduct={proceedAddProduct}
        preparation={preparation}
        partnerSelected={partnerSelected}
        partnersOptions={partnersOptions}
        handleConfirmPartnerSelection={handleConfirmPartnerSelection}
        loadingCart={loadingCart}
      />
    </>
  );
};
